export default "/assets/images/face-with-monocle.png?7aca391ccdac501607bd590630d78811";